import { debtService } from "../Services/debtService";

export default {
  API_URL: "https://lia.recife.pe.gov.br/api",
  SCHEDULE_API_URL: "http://resolveemtodolugar.web.app/api/v1",
  MESSAGE_DELAY_TIME: 2000,
  DEBT_SERVICE: debtService,
};
